<template>
    <div class="page-news">
        <content-item :title="$t('news')">
            <div class="news-list">

                <div class="news-item" v-for="(news,index) in curNews">
                    <div class="logo">
                        <div class="logo-img" v-lazy:background-image=" news.pic_url"></div>
                    </div>
                    <router-link :to="'/news/' + news.id" style="text-decoration: none;">
                        <div class="desc">
                            <div class="desc-header">
                                <p class="item-title">{{ news.title }}</p>
                            </div>
                            <div class="post-date">
                                {{ news.news_date }}
                            </div>
                            <div class="desc-content">
                                <p>{{ news.tips }}</p>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>

            <div class="news-pager" v-if="all>1">
                <div v-if="cur>1" class="pager pager-text" v-on:click="cur--;getNews(cur)">{{ $t('prevPage') }}</div>
                <div v-if="cur==1" class="pager pager-text not-allowed">{{ $t('prevPage') }}</div>
                <div v-for="index in indexs" v-bind:class="{ 'active': cur == index}" @click="btnClick(index)"
                     class="pager pager-number">
                    {{ index }}
                </div>
                <div v-if="cur<all" class="pager pager-text" v-on:click="cur++;getNews(cur)">{{ $t('nextPage') }}</div>
                <div v-if="cur==all" class="pager pager-text  not-allowed">{{ $t('nextPage') }}</div>
            </div>
        </content-item>
    </div>
</template>

<script>
    import ContentItem from './partial/ContentItem.vue'
    import md5 from 'blueimp-md5'
    import globals from '../config/global'


    export default {
        data() {
            return {
                curNews: [],
                eachPage: 20,//每页20个新闻
                all: 1, //总页数
                cur: 1//当前页码
            };
        },
        methods: {
            getNews(page) {
                let timeStamp = Date.parse(new Date());
                let sign = md5(timeStamp)
                let that = this
                let extraParam = '&platform=2'//1英卓，2萌果
                if(globals.isTest){//测试环境会获取未审核的内容
                    extraParam += '&isTest=1'
                }
                this.$http.get(globals.enjoyUrl + 'enjoysiteapi/getnews?timestamp=' + timeStamp + '&sign=' + sign + '&page=' + page
                + '&size=' + this.eachPage + extraParam
            ).then(
                function (response) {
                    that.curNews = response.data.list
                    that.all = Math.ceil(response.data.count / this.eachPage)
                    globals.methods.setStorageItem('newsData',response.data)

                });
            }
        },
        beforeMount() {
            if (globals.methods.getStorageItem('newsData')) {
                let tmp = JSON.parse(globals.methods.getStorageItem('newsData'));
                this.curNews = tmp.list
                this.all = Math.ceil(tmp.count / this.eachPage)
                return
            }
            this.getNews(1)

        },
        computed: {
            indexs() {
                let left = 1;
                let right = this.all;
                let ar = [];
                if (this.all >= 5) {
                    //这里最大范围从3到6，如果到达7，那么下边加2变成9，已经超过最大的范围值
                    if (this.cur > 3 && this.cur < this.all - 1) {
                        //以4为参考基准，左面加2右边加2
                        left = this.cur - 2
                        right = this.cur + 2
                    } else {
                        if (this.cur <= 3) {
                            left = 1
                            right = 5
                        } else {
                            right = this.all
                            left = this.all - 4
                        }
                    }
                }
                while (left <= right) {
                    ar.push(left)
                    left++
                }
                return ar
            }
        },
        components: {
            ContentItem
        }
    }
</script>


<style lang="scss" rel="stylesheet/scss" scoped>
    @import "../assets/scss/lib";

    .page-news {
        margin-top: 30px;
    }

    .news-item {
        height: 196px + 28px * 2;
        width: 100%;
        overflow: hidden;
        //@include flex-row-center;
        padding: 28px 25px;
        border-bottom: 1px solid #e0e0e0;
        box-sizing: border-box;
        &:first-child {
            height: 196px + 28px;
            padding-top: 0;
            @include cross-top;
        }
        &:last-child {
            border-bottom: none;
        }
        .logo {
            width: 349px;
            height: 196px;
            float: left;
            @include flex-grow(0);
            .logo-img {
                width: 349px;
                height: 196px;
                overflow: hidden;
                background-repeat: no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                border: 1px solid #e0e0e0;
                box-sizing: border-box;
            }
        }
        .desc {
            height: 200px;
            @include flex-grow(1);
            box-sizing: border-box;
            padding: 0 15px;
            @include flex;
            @include dir-top;
            @include main-left;
            position: relative;
            .desc-header {
                @include flex;
                @include cross-center;
                .item-title {
                    color: $orange-color;
                    font-size: 19px;
                    margin-left: 35px;
                    text-indent: -17px;
                    &::before {
                        content: ' ';
                        display: inline-block;
                        width: 13px;
                        height: 13px;
                        background: $orange-color;
                        border-radius: 50%;
                        margin-right: 5px;
                    }
                }
            }
            .post-date {
                margin: 15px 15px 20px 35px;
                color: #9e9e9e;
                font-size: 16px;
                height: 20px;
                overflow: hidden;
            }
            .desc-content {
                color: #616161;
                margin-left: 33px;
                font-size: 15.5px;
                line-height: 22px;
                text-align: justify;
            }
            .more {
                color: $orange-color;
                font-size: 20px;
                position: absolute;
                right: 15px;
                bottom: 0;
                cursor: pointer;
            }
        }
    }

    .news-pager {
        margin: 40px 0 30px;
        height: 38px;
        padding: 0 40px;
        @include flex;
        @include cross-center;
        @include main-right;
        .pager {
            a {
                height: 35px;
                width: 30px;
                line-height: 35px;
                text-align: center;
            }
            height: 35px;
            width: 30px;
            border: 1px solid #bdbdbd;
            @include flex-row-center;
            margin-left: 13px;
            cursor: pointer;
        }
        .pager-text {
            width: 100px;
            color: #999;

        }
        .pager-number {

        }
        .not-allowed {
            cursor: not-allowed;
        }
        .active {
            background: #ddd;
        }

    }
</style>


// WEBPACK FOOTER //
// News.vue?072d27eb